import { List } from 'immutable';
import { userGroupConstants } from '../constants';

export function user_groups(state = {}, action) {
  switch (action.type) {
    case userGroupConstants.USER_GROUP_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case userGroupConstants.USER_GROUP_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case userGroupConstants.USER_GROUP_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };

    case userGroupConstants.USER_GROUP_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case userGroupConstants.USER_GROUP_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case userGroupConstants.USER_GROUP_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case userGroupConstants.USER_GROUP_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case userGroupConstants.USER_GROUP_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case userGroupConstants.USER_GROUP_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const userGroupIndex = state.items.findIndex(val => val.id == action.response.id);

      if (userGroupIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(userGroupIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case userGroupConstants.USER_GROUP_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case userGroupConstants.USER_GROUP_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case userGroupConstants.USER_GROUP_DELETE_SUCCESS: {
      const { userGroupId } = action;

      if (!state.items) {
        return state;
      }

      const userGroupIndex = state.items.findIndex(val => val.id == userGroupId);

      if (userGroupIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(userGroupIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case userGroupConstants.USER_GROUP_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case userGroupConstants.USER_GROUP_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
